import { call, put, takeLatest } from "redux-saga/effects";
import { 
    downMultiplePctExcel,
    downMultiplePctPdf,
    downPctExcel,
    downPctPdf,
    getPCTInfo,
    getPctInfoList,
    getPCTNotifierSettings,
    multipleHideContacts,
    multipleHidePct,
    multipleStarContacts,
    multipleStarPct,
    multipleUnhideContacts,
    multipleUnhidePct,
    multipleUnstarContacts,
    multipleUnstarPct,
    previewPctEmail,
    savePCTNotifierSettings,
    sendPctEmail,
    unlockPct,
} from "../../helpers/backend_helper";

import { 
    getPctInfoSuccess,
    getPctNotifierSettingsSuccess,
    savePctNotifierSettingsSuccess,
    getPctInfoList as getPctInfoListAction,
    getPctInfoListSuccess,
    setPctResults,
    getPctInfoListSuccessUnlock,
    downPCtExcelSuccess,
    downloadMultiplePctExcel,
    downloadMultiplePctExcelSuccess,
    downloadPctPdfSuccess,
    downloadMultiplePctPdfSuccess,
    previewPctEmailSuccess,
    changeSentPctResult
} from "./actions";
import { cloneDeep } from 'lodash';

import { 
    DOWNLOAD_MULTIPLE_PCT_EXCEL,
    DOWNLOAD_MULTIPLE_PCT_PDF,
    DOWNLOAD_PCT_EXCEL,
    DOWNLOAD_PCT_PDF,
    GET_PCT_INFO,
    GET_PCT_INFO_LIST,
    GET_PCT_NOTIFIER_SETTINGS,
    HIDE_PCT_TARGET,
    MULTIPLE_HIDE_PCT,
    MULTIPLE_STAR_PCT,
    MULTIPLE_UNHIDE_PCT,
    MULTIPLE_UNSTAR_PCT,
    PREVIEW_PCT_EMAIL,
    SAVE_PCT_NOTIFIER_SETTINGS, 
    SEND_PCT_EMAIL, 
    STAR_PCT_TARGET,
    UNHIDE_PCT_TARGET,
    UNLOCK_PCT,
    UNSTAR_PCT_TARGET
} from "./actionTypes";
import { getUserUnlockInfo, setUpgradeAlertMessage } from "../actions";

function* onSavePCTNotifierSettings({payload: data}){
    try {
        const response = yield call(savePCTNotifierSettings, data);
        yield put(savePctNotifierSettingsSuccess(response));
    } catch (error) {
        console.log("onSavePCTNotifierSettings error >>" + error);
    }
}

function* getPctNotifierSettings() {
    try {
        const response = yield call(getPCTNotifierSettings);
        yield put(getPctNotifierSettingsSuccess(response));
    } catch (error) {
        console.log("getPctNotifierSettings error >>" + error);
    }
}

function* getPctInfo({payload: data}) {
    // console.log("run pct info saga")
    try {
        const response = yield call(getPCTInfo, data);
        // console.log("getPctInfo response >>" + JSON.stringify(response.pctInfo));
        yield put(getPctInfoSuccess(response));
    } catch (error) {
        console.log("getPctInfo error >>" + error);
    }
}

function* onGetPctInfoList({payload: data}) {
    try {
        const response = yield call(getPctInfoList, {pctNotifierList:data});
        yield put(getPctInfoListSuccess(response));
    } catch (error) {
        console.log("getPctInfo error >>" + error);
    }
}

function* onMultipleStarPctCases({payload: data}) {
    try {
        const response = yield call(multipleStarPct, data);
        yield put(getPctInfoListAction(data));
    } catch (error) {
        console.log("onStarPctCases error >>" + error);
    }
}

function* onMultipleUnstarPctCases({payload: data}) {
    try {
        const response = yield call(multipleUnstarPct, data);
        yield put(getPctInfoListAction(data));
    } catch (error) {
        console.log("onUnstarPctCases error >>" + error);
    }
}

function* onMultipleHidePctCases({payload: data}) {
    try {
        const response = yield call(multipleHidePct, data);
        yield put(getPctInfoListAction(data));
    } catch (error) {
        console.log("onHidePctCases error >>" + error);
    }
}

function* onMultipleUnhidePctCases({payload: data}) {
    try {
        const response = yield call(multipleUnhidePct, data);
        yield put(getPctInfoListAction(data));
    } catch (error) {
        console.log("onUnhidePctCases error >>" + error);
    }
}

function* onStarPctTarget({payload: data}) {
    try {
        const response = yield call(multipleStarContacts, [{targetGroupNo: data.targetGroupNo}]);
        if(response.result === 'Success'){
        yield put(getPctInfoListAction(data.pctNotifierList));
        }
    } catch (error) {
        console.log("onStarPctTarget error >>" + error);
    }
}

function* onUnstarPctTarget({payload: data}) {
    try {
        const response = yield call(multipleUnstarContacts, [{targetGroupNo: data.targetGroupNo}]);
        if(response.result === 'Success'){
        yield put(getPctInfoListAction(data.pctNotifierList));
        }
    } catch (error) {
        console.log("onStarPctTarget error >>" + error);
    }
}

function* onHidePctTarget({payload: data}) {
    try {
        const response = yield call(multipleHideContacts, [{targetGroupNo: data.targetGroupNo}]);
        if(response.result === 'Success'){
        yield put(getPctInfoListAction(data.pctNotifierList));
        }
    } catch (error) {
        console.log("onStarPctTarget error >>" + error);
    }
}

function* onUnhidePctTarget({payload: data}) {
    try {
        const response = yield call(multipleUnhideContacts, [{targetGroupNo: data.targetGroupNo}]);
        if(response.result === 'Success'){
        yield put(getPctInfoListAction(data.pctNotifierList));
        }
    } catch (error) {
        console.log("onStarPctTarget error >>" + error);
    }
}

function* onUnlockPct({payload: data}) {
    try {
        const response = yield call(unlockPct, data);
        if(response.error !== undefined && response.error> -1){
          yield put(getUserUnlockInfo()); 
          yield put(setPctResults(response.error));
      }else{
        if(response.result === "Success"){
          yield put(getUserUnlockInfo());
    
        if(response.remainUnlockCnt == 0 && response.remainPctUnlockCnt == 0){
          yield put(setUpgradeAlertMessage({title:"You have used your final credit.",text:"Upgrade your WeCrest plan, or wait until you receive more free credits on Monday."}));
        }
      }else{
          yield put(getUserUnlockInfo());
          yield put(setPctResults(response.result));
      }
    }
        if (response.unlockList) {
          let _caseList = cloneDeep(data.pctNotifierList);
          let _pctNotifierList = [];
          data.pctNotifierList.map((caseData, index) => {
            response.unlockList.map((unlockData, index2) => {
              if (caseData.repRankCode == unlockData.repRankCode) {
                // console.log('repRankCode >> ' + unlockData.repRankCode);
                let _caseData = cloneDeep(caseData);
                _caseData.pubNumber = unlockData.irNumber;
                _pctNotifierList.push(_caseData);
                return;
              }
            })
          })
          _caseList = _pctNotifierList;
          // console.log("FINAL CASELIST >>") 
          // console.log(_caseList)
    
       const response2 =  yield call(getPctInfoList, {pctNotifierList:_caseList});
       // console.log(data.pctNotifierList.length, response.unlockList.length, _caseList.length, response2.pctInfo.length)
       yield put(getPctInfoListSuccessUnlock(response2))
          
      }
    } catch (error) {
        console.log("onUnlockPct error >>" + error);
    }
}

function* onDownloadPctExcel ({payload: data}) {
    try {
        yield call(downPctExcel, data);
        yield put(downPCtExcelSuccess());
    } catch (error) {
        console.log("onDownloadPctExcel error >>" + error);
    }
}

function* onDownloadMultiplePctExcel ({payload: data}) {
    try {
        yield call(downMultiplePctExcel, data);
        yield put(downloadMultiplePctExcelSuccess());
    } catch (error) {
        console.log("onDownloadMultiplePctExcel error >>" + error);
    }
}

function* onDownloadPctPdf ({payload: data}) {
    try {
        yield call(downPctPdf, data);
        yield put(downloadPctPdfSuccess);
    } catch (error) {
        console.log("onDownloadPctPdf error >>" + error);
    }
}

function* onDownloadMultiplePctPdf ({payload: data}) {
    try {
        yield call(downMultiplePctPdf, data);
        yield put(downloadMultiplePctPdfSuccess());
    } catch (error) {
        console.log("onDownloadMultiplePctPdf error >>" + error);
    }
}

function* onPreviewPctEmail({ payload: data}){
    try {
        const response = yield call(previewPctEmail, data);
        yield put(previewPctEmailSuccess(response));
    } catch (error) {
        console.log("onPreviewPctEmail error >> " + error);
    }
}

function* onSendPctEmail({ payload: data }) {
  try {
    const response = yield call(sendPctEmail, data);
    if(response.error !== undefined && response.error > -1){
      yield put(setPctResults(response.error));
    }else{
      yield put(changeSentPctResult(response));
     console.log("SUCCESS")
    }

    const response2 = yield call(getPctInfoList, {pctNotifierList:data.pctNotifierList});
    yield put (getPctInfoListSuccess(response2));
  } catch (error) {
    console.log("onSendPctEmail error >> " + error);
  }
}

function* pctNotifierSaga() {
    yield takeLatest(SAVE_PCT_NOTIFIER_SETTINGS, onSavePCTNotifierSettings);
    yield takeLatest(GET_PCT_NOTIFIER_SETTINGS, getPctNotifierSettings);
    yield takeLatest(GET_PCT_INFO, getPctInfo);
    yield takeLatest(GET_PCT_INFO_LIST, onGetPctInfoList);
    yield takeLatest(MULTIPLE_STAR_PCT, onMultipleStarPctCases);
    yield takeLatest(MULTIPLE_UNSTAR_PCT, onMultipleUnstarPctCases);
    yield takeLatest(MULTIPLE_HIDE_PCT, onMultipleHidePctCases);
    yield takeLatest(MULTIPLE_UNHIDE_PCT, onMultipleUnhidePctCases);
    yield takeLatest(STAR_PCT_TARGET, onStarPctTarget);
    yield takeLatest(UNSTAR_PCT_TARGET, onUnstarPctTarget);
    yield takeLatest(HIDE_PCT_TARGET, onHidePctTarget);
    yield takeLatest(UNHIDE_PCT_TARGET, onUnhidePctTarget);
    yield takeLatest(UNLOCK_PCT, onUnlockPct);
    yield takeLatest(DOWNLOAD_PCT_EXCEL, onDownloadPctExcel);
    yield takeLatest(DOWNLOAD_MULTIPLE_PCT_EXCEL, onDownloadMultiplePctExcel);
    yield takeLatest(DOWNLOAD_PCT_PDF, onDownloadPctPdf);
    yield takeLatest(DOWNLOAD_MULTIPLE_PCT_PDF, onDownloadMultiplePctPdf);
    yield takeLatest(PREVIEW_PCT_EMAIL, onPreviewPctEmail)
    yield takeLatest(SEND_PCT_EMAIL, onSendPctEmail);
}

export default pctNotifierSaga;